import { Drawer, styled } from "@mui/material";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: 250, // Уменьшил с 300 до 250
    borderRight: 0,
    // Колонка фиксированной высоты: длинное меню скроллится внутри себя,
    // а не выдавливает шапку с карточкой пользователя
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    msOverflowStyle: "none", // IE 10+
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
      display: "none", // Safari and Chrome
    },
  },
});
